import { useEffect } from "react";

export const useEqualHeight = (elements: React.RefObject<HTMLElement>[]) => {
  useEffect(() => {
    if (!elements.length) return;

    const maxHeight = Math.max(
      ...elements.map((ref) => (ref.current ? ref.current.clientHeight : 0)),
    );

    elements.forEach((ref) => {
      if (ref.current) {
        ref.current.style.height = `${maxHeight}px`;
      }
    });
  }, [elements]);
};
